import {
  GET_PRODUCTHANDOVER,
  GET_PRODUCTHANDOVER_SUCCESS,
  GET_PRODUCTHANDOVER_FAIL,
  DELETE_PRODUCTHANDOVER,
  DELETE_PRODUCTHANDOVER_SUCCESS,
  DELETE_PRODUCTHANDOVER_FAIL,
  UPDATE_PRODUCTHANDOVER,
  UPDATE_PRODUCTHANDOVER_SUCCESS,
  UPDATE_PRODUCTHANDOVER_FAIL,
  ADD_NEW_PRODUCTHANDOVER,
  ADD_PRODUCTHANDOVER_SUCCESS,
  ADD_PRODUCTHANDOVER_FAIL,
  PRODUCTHANDOVER_LOADING,
  PRODUCTHANDOVER_RESET,
} from "./actionType";

export const resetProductHandoverState = (actionType) => ({
  type: PRODUCTHANDOVER_RESET,
  payload: { actionType },
});

export const getProductHandoverSuccess = (actionType, data) => ({
  type: GET_PRODUCTHANDOVER_SUCCESS,
  payload: { actionType, data },
});

export const getProductHandoverFail = (actionType, error) => ({
  type: GET_PRODUCTHANDOVER_FAIL,
  payload: { actionType, error },
});

export const getProductHandover = data => ({
  type: GET_PRODUCTHANDOVER,
  payload: data,
});

export const getProductHandoverLoading = () => ({
  type: PRODUCTHANDOVER_LOADING
});

export const deleteProductHandover = data => ({
  type: DELETE_PRODUCTHANDOVER,
  payload: data,
});

export const deleteProductHandoverSuccess = data => ({
  type: DELETE_PRODUCTHANDOVER_SUCCESS,
  payload: data,
});

export const deleteProductHandoverFail = error => ({
  type: DELETE_PRODUCTHANDOVER_FAIL,
  payload: error,
});

export const updateProductHandover = data => ({
  type: UPDATE_PRODUCTHANDOVER,
  payload: data,
});

export const updateProductHandoverFail = error => ({
  type: UPDATE_PRODUCTHANDOVER_FAIL,
  payload: error,
});

export const updateProductHandoverSuccess = data => ({
  type: UPDATE_PRODUCTHANDOVER_SUCCESS,
  payload: data,
});

export const addNewProductHandover = data => ({
  type: ADD_NEW_PRODUCTHANDOVER,
  payload: data,
});

export const addProductHandoverSuccess = data => ({
  type: ADD_PRODUCTHANDOVER_SUCCESS,
  payload: data,
});

export const addProductHandoverFail = error => ({
  type: ADD_PRODUCTHANDOVER_FAIL,
  payload: error,
});